<template>
  <div class="bottom-nav">
    <router-link class="nav-item" :class="{ active: $route.path === '/home' }" to="/home">
      <span class="ico">⌂</span><span>首页</span>
    </router-link>
    <router-link class="nav-item" :class="{ active: $route.path.startsWith('/search') }" to="/search">
      <span class="ico">⌕</span><span>检索</span>
    </router-link>
    <span class="nav-item" :class="{ active: $route.path.startsWith('/publish') }" @click="goPublish">
      <span class="ico">＋</span><span>发布</span>
    </span>
    <router-link class="nav-item" :class="{ active: $route.path.startsWith('/audit') }" to="/audit">
      <span class="ico">✓</span><span>审核</span>
    </router-link>
    <span class="nav-item" :class="{ active: $route.path.startsWith('/workbench') || $route.path.startsWith('/profile') }" @click="goMine">
      <span class="ico">◔</span><span>我的</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  methods: {
    goPublish() {
      if (!this.$store.getters.isLoggedIn) {
        this.$router.push('/login')
        return
      }
      // 根据用户类型跳转默认发布页
      this.$router.push('/publish/demand')
    },
    goMine() {
      if (!this.$store.getters.isLoggedIn) {
        this.$router.push('/login')
        return
      }
      const typeMap = { ALUMNI: 'alumni', TEACHER: 'teacher', DEPARTMENT: 'dept' }
      const t = typeMap[this.$store.getters.userType] || 'alumni'
      this.$router.push('/workbench/' + t)
    }
  }
}
</script>
